// extracted by mini-css-extract-plugin
export default {"wrapper":"Wrapper_wrapper__GC3yJ"};